"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utilities_1 = require("../../Themes/utilities");
const polished_1 = require("polished");
const react_1 = tslib_1.__importDefault(require("react"));
const StatusBarButton_1 = tslib_1.__importDefault(require("./StatusBarButton"));
const StatusBarDropdown_1 = tslib_1.__importDefault(require("./StatusBarDropdown"));
const StatusBarItem_1 = tslib_1.__importDefault(require("./StatusBarItem"));
const StatusBarSpacer_1 = tslib_1.__importDefault(require("./StatusBarSpacer"));
const styled_components_1 = tslib_1.__importDefault(require("../../Themes/styled-components"));
const BASE_ZINDEX = 60;
const Wrapper = styled_components_1.default.div `
  height: ${(0, polished_1.rem)(48)};
  background-color: ${({ theme }) => theme.backgroundColor};
  width: 100%;
  z-index: ${BASE_ZINDEX};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  display: flex;
  ${(0, utilities_1.mb)('l')} {
    & > *:not(:last-child) {
      border-right: 1px solid ${({ theme }) => theme.separatorColor};
    }
  }
`;
const StatusBar = ({ children, className, }) => {
    return react_1.default.createElement(Wrapper, { className: className }, children);
};
StatusBar.Button = StatusBarButton_1.default;
StatusBar.DropDown = StatusBarDropdown_1.default;
StatusBar.Spacer = StatusBarSpacer_1.default;
StatusBar.Item = StatusBarItem_1.default;
exports.default = StatusBar;
